<template>
  <!-- Lazy - Same Picture -->
  <img
    v-if="lazy == 'lazy1'"
    ref="lazy"
    class="lazyload blur-up"
    data-sizes="auto"
    loading="lazy"
    :src="picture.lazy.url"
    :data-srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
    :width="picture.lazy.width"
    :height="picture.lazy.height"
    :style="{'object-fit': config.objectFit}"
    />
  <!-- Lazy - Vuew Lazy Load -->
  <img
    v-else-if="lazy == 'lazy2'"
    ref="lazy2"
    v-lazy="picture.lazy.url"
    :data-srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
  />
  <!-- Lazy - Google -->
  <img
    v-else-if="lazy == 'lazy3'"
    ref="lazy3"
    class="lazy3"
    :src="picture.lazy.url"
    :data-srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
  />
  <!-- Lazy - Opacity -->
  <img
    v-else-if="lazy == 'lazy4' && !srcset"
    ref="lazy4"
    class="lazy4"
    @load="onLoadLazy4"
    :src="picture.default.url"
  />
  <img
    v-else-if="lazy == 'lazy4' && srcset"
    ref="lazy4"
    class="lazy4"
    @load="onLoadLazy4"
    :srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
  />
  <!-- Not Lazy -->
  <img
    v-else-if="!srcset"
    ref="img"
    :src="picture.default.url"
  />
  <img
    v-else 
    ref="img"
    :srcset="`
      ${picture[1400].url} 1400w,
      ${picture[1080].url} 1080w,
      ${picture[750].url} 750w,
      ${picture[640].url} 640w,
      ${picture[480].url} 480w,
      ${picture[320].url} 320w,
      ${picture[240].url} 240w,
    `"
  />
</template>

<script>
export default {
  props: {
    lazy: {
      type: [Boolean, String],
      default: true,
    },
    srcset: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default() {
        return {
          imageRaw: String,
          mode: String,
          cropPosX: Number,
          cropPosY: Number,
          cropWidth: Number,
          cropHeight: Number,
          resizeWidth: Number,
          resizeHeight: Number,
          maxWidthDesktop: Number,
          maxWidthTablet: Number,
          maxWidthMobile: Number,
          quality: Number,
        };
      },
    },
  },
  computed: {
    picture() {
      if (!this.srcset) return { 
        default: {
          url: this.config.imageRaw.replace('{{size}}', 'm_1920x0'),
        }
      };
      return {
        1400: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[1400].w}}),
        1080: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[1080].w}}),
        750: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[750].w}}),
        640: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[640].w}}),
        480: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[480].w}}),
        320: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[320].w}}),
        240: this.$helper.imageCrop.imageOptions("desktop", {...this.config, ...{maxWidthDesktop : this.sizes[240].w}}),
        lazy: this.$helper.imageCrop.imageOptions("lazy", this.config),
      };
    },
  },
  data() {
    return {
      sizes: {
          "1400" : {
            w: 1920, // 1920
            h: 1920,
          },
          "1080": {
            w: 1400, // 1110
            h: 1400,
          },
          "750": {
            w: 1080, // 666
            h: 1080,
          },
          "640": {
            w: 750, // 555
            h: 750,
          },
          "480": {
            w: 640, // 444
            h: 640,
          },
          "320": {
            w: 480, // 370
            h: 480,
          },
          "240": {
            w: 320, // 278
            h: 320,
          }
        }
    };
  },
  methods: {
    // lazyload3() {
    //   var lazyImages = [].slice.call(document.querySelectorAll("img.lazy3"));
    //   console.log({ lazyImages });

    //   if ("IntersectionObserver" in window) {
    //     let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
    //       entries.forEach(function(entry) {
    //         if (entry.isIntersecting) {
    //           let lazyImage = entry.target;
    //           lazyImage.src = lazyImage.dataset.src;
    //           lazyImage.srcset = lazyImage.dataset.srcset;
    //           lazyImage.classList.remove("lazy");
    //           lazyImageObserver.unobserve(lazyImage);
    //         }
    //       });
    //     });

    //     lazyImages.forEach(function(lazyImage) {
    //       lazyImageObserver.observe(lazyImage);
    //     });
    //   } else {
    //     // Possibly fall back to event handlers here
    //   }
    // },
    onLoadLazy4() {
      this.visibleLazy4();
    },
    visibleLazy4() {
      let img = this.$refs.lazy4;
      if (img.getBoundingClientRect().top <= window.innerHeight && !img.classList.contains('loaded')) {
        img.classList.add('loaded');
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.visibleLazy4);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.visibleLazy4);
  },
};
</script>

<style scoped>
img.lazy4:not(.fill) {
  opacity: 0;
  max-width:100%;
  overflow: hidden;
  transition: opacity .3s ease-in-out,transform .3s ease-in-out;
  -webkit-transition: opacity .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
img.lazy4.loaded {
  opacity: 1;
}
</style>